// extracted by mini-css-extract-plugin
export var bookingLink = "card--event-module--booking-link--a59ee";
export var bookingReq = "card--event-module--booking-req--01e7f";
export var content = "card--event-module--content--a1b82";
export var costWrapper = "card--event-module--cost-wrapper--388ba";
export var location = "card--event-module--location--c5195";
export var timesGrid = "card--event-module--times-grid--24bf5";